import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ColorScheme } from '../extensions/colorscheme';

@Component({
  selector: 'app-base-quantityselector',
  template: `
    <p>
      base quantityselector works!
    </p>
  `,
  styles: [],
})
export class BaseQuantityselectionComponent extends ColorScheme {

  @Input() min: number = 0;
  @Input() max: number = 9999999999;

  @Input() set quantity(value: number) {
      this._quantity = Number(value);
  }

  @Input() set small(value: boolean | string) {
    if (value || value === '')
      this._small = true
  }
  @Input() editable = true;

  @Output() quantityChange: EventEmitter<number> = new EventEmitter<number>()


  _quantity: number = 0;
  _small = false;


  constructor() {
    super()
  }


  changeQty(qty: number) {
    const newqty = this._quantity + qty
    if (newqty >= this.min && newqty <= this.max) {
      this._quantity = newqty;
    }
    this.quantityChange.emit(this._quantity)
  }


}
